// Zibal rejects a /start request without a Referer header (Shaparak requires
// the Referer, the callback URL and the gateway's registered domain to share
// the same root domain). A plain `window.location` assignment inherits
// whatever referrer policy the serving page happens to carry, so the gateway
// redirect goes through an anchor with an explicit "origin" policy: the
// gateway always receives https://panel.gerdoo.cloud/ and never the full path.
export function redirectToPaymentGateway(paymentUrl: string) {
  const a = document.createElement("a");
  a.href = paymentUrl;
  a.referrerPolicy = "origin";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
}
